export const buttonClassName = 'bg-yellow-400 hover:bg-yellow-500 text-black';

export const iconProps = {
  icon: 'person_add_btn',
  iconWidth: 20,
  iconHeight: 20,
};
